export default __webpack_public_path__ + "static/media/empty-box.048847d6.svg";